import { render, staticRenderFns } from "./HotelMealBook.vue?vue&type=template&id=61bbd64c&scoped=true&"
import script from "./HotelMealBook.vue?vue&type=script&lang=ts&"
export * from "./HotelMealBook.vue?vue&type=script&lang=ts&"
import style1 from "./HotelMealBook.vue?vue&type=style&index=1&id=61bbd64c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bbd64c",
  null
  
)

export default component.exports